export const propertyDetail = {
  fontSize: '32px',
  fontFamily: 'poppins',
  fontWeight: 600,
};

export const BuyerSection = {
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  margin: '20px',
  marginTop: '25px',
};
export const graphbox = {
  height: '20px',
  width: '20px',
  border: '1px solid grey',
  display: 'inline-block',
};
